import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import {
  getPurchaseReturnBranch,
  getPurchaseReturnBranchById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getPurchaseInvoiceDetail,
  createPurchaseReturnBranch,
  getPurchaseReturnBranchAdditionalChargeList,
} from "./thunk";
import { act } from "react";

const initialState = {
  purchaseReturnBranchs: [],
  edit: false,
  purchaseReturnBranch: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseReturnBranch: false,
  loadingNext: false,
  loadingDetails: false,
  purchaseInvoiceDetails: [
    {
      unique: uuidv4(),
      product: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate().toADasDate()),
    },
  ],
  additionalCharges: [],
  saveAndContinue: false,
  showCreateModal: false,
  selectedPurchaseInvoice: null,
  selectedPurchaseInvoiceDetails: [],
  formData: {
    branch: null,
    orderNo: "",
    forBranch: null,
    purchaseOrderInvoice: null,
    partyAccount: null,
    // refundAmount: "",
    grandTotal: "",
    remarks: "",
    documentsAttach: [],
    voucherDateBs: new NepaliDate().format("YYYY-MM-DD"),
    purchaseReturnBranchMainPartyDetails: {
      jobNumber: "",
    },
    purchaseReturnBranchMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: "",
    },
  },
};

export const purchaseReturnBranchSlice = createSlice({
  name: "purchaseReturnBranch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setMainOrder: (state, action) => {
      state.selectedPurchaseInvoice = action.payload;
    },

    setOrderDetails: (state, action) => {
      state.selectedPurchaseInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },

    purchaseInvoiceDetailsUpdated: (state, action) => {
      state.purchaseInvoiceDetails = action.payload;
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    setPurchaseInvoiceDetails: (state, action) => {
      state.purchaseInvoiceDetails = [
        ...action.payload.map((value) => ({
          ...value,
          description: value.product?.name || "",
          actualQuantity: value.actualQuantity - value.returnQuantity,
          validateQuantity: value.actualQuantity - value.returnQuantity,
          amount: value.rate * (value.actualQuantity - value.returnQuantity),
        })),
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },
    clearSelectedOrderData: (state) => {
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
    },
    clearPurchaseInvoiceDetails: (state) => {
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },
    clearAllPurchaseReturnBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseReturnBranch = false;
      state.purchaseReturnBranch = null;
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
      state.additionalCharges = [];
      state.saveAndContinue = false;
      state.formData = initialState.formData;
    },
    savePurchaseReturnBranchForm: (state, action) => {
      state.formData = action.payload;
    },
    resetPurchaseReturnBranchForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseReturnBranch;
      } else {
        state.formData = initialState.formData;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPurchaseReturnBranchAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getPurchaseReturnBranchAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getPurchaseReturnBranchAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });
    // invoice details
    builder.addCase(createPurchaseReturnBranch.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createPurchaseReturnBranch.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createPurchaseReturnBranch.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseInvoiceDetail.pending, (state) => {
      state.loadingDetails = true;
      // state.purchaseInvoiceDetails = null;
    });
    builder.addCase(getPurchaseInvoiceDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      // state.purchaseInvoiceDetails = action.payload.data.purchaseInvoiceDetail;
    });
    builder.addCase(getPurchaseInvoiceDetail.rejected, (state) => {
      state.loadingDetails = false;
      // state.purchaseInvoiceDetails = null;
    });
    // getPurchaseReturnBranchById
    builder.addCase(getPurchaseReturnBranchById.pending, (state) => {
      state.loading = true;
      state.purchaseReturnBranch = null;
    });
    builder.addCase(getPurchaseReturnBranchById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.purchaseReturnBranch = action.payload.data;
      state.purchaseInvoiceDetails = action.payload.data?.purchaseOrderReturnDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      // state.formData = action.payload.data;
      const main = action.payload.data?.purchaseReturnBranchMain || {};
      state.formData = {
        branch: main.branch || null,
        orderNo: main.orderNo || "",
        forBranch: main.forBranch || null,
        purchaseOrderInvoice: main.purchaseOrderInvoice || null,
        partyAccount: main.partyAccount || null,
        grandTotal: main.grandTotal || "",
        remarks: main.remarks || "",
        documentsAttach: main.documentsAttach || [],
        voucherDateBs: main.voucherDateBs || new NepaliDate().format("YYYY-MM-DD"),
        purchaseReturnBranchMainPartyDetails: {
          jobNumber: main.purchaseReturnBranchMainPartyDetails?.jobNumber || "",
        },
        purchaseReturnBranchMainVehicleDetail: {
          vehicleNo: main.purchaseReturnBranchMainVehicleDetail?.vehicleNo || "",
          builtyNo: main.purchaseReturnBranchMainVehicleDetail?.builtyNo || "",
          driverName: main.purchaseReturnBranchMainVehicleDetail?.driverName || "",
          driverPhoneNo: main.purchaseReturnBranchMainVehicleDetail?.driverPhoneNo || "",
          driverAddress: main.purchaseReturnBranchMainVehicleDetail?.driverAddress || "",
          licenseNo: main.purchaseReturnBranchMainVehicleDetail?.licenseNo || "",
          transporter: main.purchaseReturnBranchMainVehicleDetail?.transporter || "",
          quantity: main.purchaseReturnBranchMainVehicleDetail?.quantity || "",
        },
      };
    });
    builder.addCase(getPurchaseReturnBranchById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseReturnBranch = null;
    });
    builder.addMatcher(
      isAnyOf(
        getPurchaseReturnBranch.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseReturnBranch = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseReturnBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseReturnBranch = false;
        state.purchaseReturnBranchs = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPurchaseReturnBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseReturnBranch = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setMainOrder,
  setOrderDetails,
  purchaseInvoiceDetailsUpdated,
  updatedAdditionalCharges,
  setPurchaseInvoiceDetails,
  savePurchaseReturnBranchForm,
  clearSelectedOrderData,
  clearPurchaseInvoiceDetails,
  clearAllPurchaseReturnBranch,
  resetPurchaseReturnBranchForm,
} = purchaseReturnBranchSlice.actions;

export default purchaseReturnBranchSlice.reducer;
